import { render, staticRenderFns } from "./UploadAvatarDialog.vue?vue&type=template&id=9d20efd8&scoped=true"
import script from "./UploadAvatarDialog.vue?vue&type=script&lang=js"
export * from "./UploadAvatarDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadAvatarDialog.vue?vue&type=style&index=0&id=9d20efd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d20efd8",
  null
  
)

export default component.exports